module.exports = __webpack_public_path__ + "static/media/campaign-by-division.94d66acb.png";